module.exports = __webpack_public_path__ + "static/media/b.5dd53f19.png";